"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PoweredByGoogle = exports.DropdownBody = exports.StyledInput = exports.DropdownWrapper = void 0;
const horizon_util_ts_tokens_1 = require("@daytrip/horizon-util-ts-tokens");
const styled_components_1 = __importStar(require("styled-components"));
const Input_1 = require("../input/Input");
const Dimensions_1 = require("../utils/Dimensions");
const transformPixelsToRem_1 = require("../utils/transformers/transformPixelsToRem");
exports.DropdownWrapper = styled_components_1.default.div `
    position: relative;
    height: ${Dimensions_1.Dimensions.d48};
    outline: none;
    margin-bottom: ${({ spacing }) => spacing};
`;
exports.StyledInput = (0, styled_components_1.default)(Input_1.Input) `
    ${({ isOpen, isPlacePredictionsLoading }) => isOpen &&
    !isPlacePredictionsLoading &&
    (0, styled_components_1.css) `
            border-bottom-left-radius: 0;
            border-bottom-right-radius: 0;
        `};

    ${({ isOpen, isValid }) => isOpen &&
    (0, styled_components_1.css) `
            border-color: ${isValid === false ? horizon_util_ts_tokens_1.Colors.Red400 : horizon_util_ts_tokens_1.Colors.Blue400} !important;
        `}

    ${({ isValid }) => (0, styled_components_1.css) `
        &:focus::not(:placeholder-shown) {
            border-color: ${isValid === false ? horizon_util_ts_tokens_1.Colors.Red400 : horizon_util_ts_tokens_1.Colors.Blue400} !important;
        }
    `};
`;
exports.DropdownBody = styled_components_1.default.div `
    position: absolute;
    top: calc(100% - 2px);
    left: 0;
    right: 0;
    background: white;
    border-radius: 0 0 ${(0, transformPixelsToRem_1.transformPixelsToRem)(5)} ${(0, transformPixelsToRem_1.transformPixelsToRem)(5)};
    border-width: 1px;
    border-style: solid;
    border-color: ${horizon_util_ts_tokens_1.Colors.Blue400};
    border-top-color: ${horizon_util_ts_tokens_1.Colors.Grey200} !important;
    overflow-y: auto;
    overflow-x: hidden;
    z-index: 10;

    & > * {
        cursor: pointer;
    }

    ${({ isValid }) => isValid === false &&
    (0, styled_components_1.css) `
            border-color: ${horizon_util_ts_tokens_1.Colors.Red400};
        `}
`;
exports.PoweredByGoogle = styled_components_1.default.div `
    display: flex;
    align-self: center;
    justify-content: flex-end;
    margin: ${Dimensions_1.Dimensions.d4};
    margin-left: auto;
    pointer-events: none;

    img {
        width: 144px;
        height: 18px;
    }
`;
//# sourceMappingURL=AddressAutocomplete.styles.js.map